import {Badge, Group, rem, UnstyledButton} from "@mantine/core";
import {Tooltip} from "@ots-frontend/ots-ui";
import {useNavigate} from "react-router-dom";
import {useNavIslandCounts} from "../../hooks/useNavIslandCounts";
import {IconBellExclamation} from "@tabler/icons-react";
import {useTranslation} from "react-i18next";
import {ContainerLevelSimulationBadge} from "@ots-frontend/ots-ui-tw";

export type NavHeaderIslandProps = {
  // props here
}

export const NavHeaderIsland = (props: NavHeaderIslandProps) => {
  const navigate = useNavigate()

  const { t } = useTranslation(["common"])

  const {unauthorizedDispatchRequestCount, availableLoads, potentialShutInsCount} = useNavIslandCounts()

  return (
    <Group position="left">
      <ContainerLevelSimulationBadge onClick={() => navigate("/directory")}/>
      {unauthorizedDispatchRequestCount > 0 &&
        <UnstyledButton onClick={() => navigate("/requests/unauthorized")}>
          <Badge size="sm" variant="filled" color="service-work">
            {`${unauthorizedDispatchRequestCount} Unauthorized Dispatch Requests`}
          </Badge>
        </UnstyledButton>
      }
      {availableLoads > 0 &&
        <UnstyledButton onClick={() => navigate("/container-status")}>
          <Badge size="sm" variant="filled" color="service-work">
            {`${availableLoads} Available Loads`}
          </Badge>
        </UnstyledButton>
      }
      {potentialShutInsCount > 0 &&
        <Tooltip
          label={t("common.entity.container.potentialshutin.desc", "Potential Shut-Ins are containers that are set to 'Do Not Dispatch' but whose fill or time to fill is critically high.")}
          withinPortal={true}>
          <UnstyledButton onClick={() => navigate("/container-status/shut-ins")}>
            <Badge size="sm" variant="filled" color="red">
              <Group spacing={7}>
                <IconBellExclamation size={rem(12)} />
                {`${potentialShutInsCount} Potential Shut-Ins`}
              </Group>
            </Badge>
          </UnstyledButton>
        </Tooltip>
      }
    </Group>
  );
};
